<template>
<div>
    <div class="content">
        <div class="cont-list">
            <span class="list">{{
          this.parentRoute.menuName + "-" + this.route.menuName
        }}</span>
            <span class="masge">当前共有{{ total }}条{{ this.route.menuName }}</span>
        </div>
        <div class="header">
            <div class="left">
                <el-button v-if="tableAcl.indexOf('Add') != -1" class="btn primary" type="primary" size="small" v-preventReClick @click="handleAdd">新增</el-button>
                <el-button v-if="tableAcl.indexOf('Remove') != -1" class="btn" size="small" type="danger" :disabled="multiple" v-preventReClick @click="handleDelete">删除</el-button>

                <SelectFilter ref="selectFilter" :options="filterOptions" :query="query" @filterChange="filterChange" @reset="reset"></SelectFilter>
            </div>
            <div class="right">
                <el-button class="btn primary" type="primary" style="margin-right: 10px"
                @click="showTransfer">自定义设置</el-button>
                <div class="search">
                    <el-input type="text" v-model="query.keyWord" @keyup.enter.native="queryChange">
                        <i slot="suffix" class="el-icon-search" @click="queryChange"></i>
                    </el-input>
                    <!-- <i class="el-icon-search padding10" v-preventReClick @click="queryChange"></i> -->
                </div>
                <span v-preventReClick @click="reset">重置</span>
            </div>
        </div>
        <div v-if="tableHaeder.length>0">
            <CustomTable  ref="customTable" :tableData="tableData" @handleSelectionChange="handleSelectionChange" :tableHaeder="tableHaeder" :loading="loading"
            @resetMethod="reset" :tableHeight="tableHeight" @onApproveStatusSuccess="getData" :tableCode="route.name"> 
            <template slot="before">
              <el-table-column align="center" :reserve-selection="true" type="selection" fixed width="55">
              </el-table-column>
            </template>
              <template slot="after">
                <el-table-column fixed="right" prop="operation" label="操作" width="180">
                    <template slot-scope="scope">
                        <el-button type="text" v-preventReClick @click="handleInfo(scope.row)" class="color-blue">查看</el-button>
                        <el-button v-if="scope.row.status == 1 && isShowApproveButton(scope.row.approverIds)" type="text" v-preventReClick @click="handleApprove(scope.row)" class="margin-left20 color-blue">审核</el-button>
                        <el-button v-else-if="scope.row.status != 1 &&scope.row.status != 2 &&tableAcl.indexOf('Edit') != -1 " type="text" v-preventReClick @click="handleUpdate(scope.row)" class="margin-left20 color-blue">编辑</el-button>
                        <!-- <span v-else class="margin-left20 color-blue">&nbsp;&nbsp;-&nbsp;&nbsp;</span> -->
                        <el-button v-if="tableAcl.indexOf('Remove') != -1 && scope.row.status != 2" type="text" v-preventReClick @click="handleDelete(scope.row)" class="margin-left20 color-blue">删除</el-button>
                        <!-- <span v-else class="margin-left20 color-blue">&nbsp;&nbsp;-&nbsp;&nbsp;</span> -->
                        <el-button type="text" v-preventReClick @click="showRefundDialog(scope.row)" v-if="
                    scope.row.status == 2 &&
                    scope.row.refundState == 0 &&
                    scope.row.state != 3 &&
                    scope.row.returnState == 1
                  " class="margin-left20 color-blue">退货</el-button>
                    </template>
                </el-table-column>
              </template>
            </CustomTable>
          </div>
          <div v-else>
            <el-table ref="multipleTable" border row-key="id" v-loading="loading" :data="tableData" :max-height="tableHeight" style="width: 100%" @selection-change="handleSelectionChange" stripe :header-cell-style="{ background: '#DDEBFF' }">
                <template slot="empty">
                    <div class="empty-div" :style="{ height: tableHeight + 'px' }">
                        <img src="../../../../assets/noData.png" width="240" height="240" />
                        <span class="empty-span">抱歉！当前搜索状态下暂无相关数据，请核对后再查询！</span>
                        <div class="empty-rest" @click="reset">恢复默认</div>
                    </div>
                </template>
                <el-table-column align="center" :reserve-selection="true" type="selection" fixed width="55">
                </el-table-column>
                <el-table-column width="170" prop="no" label="跟台验收单号">
                  <template slot-scope="scope">
                    <span>
                      <el-link type="primary" @click="handleInfo(scope.row)">{{ scope.row.no }}</el-link>
                    </span>
                  </template>
                </el-table-column>
                <el-table-column width="100" prop="stateName" label="状态"></el-table-column>
                <el-table-column prop="oneLevelWarehouseName" label="收货库房" min-width="160" show-overflow-tooltip></el-table-column>
                <el-table-column :show-overflow-tooltip="true" width="160" prop="supplierName" label="供应商"></el-table-column>
                <el-table-column width="120" prop="patientName" label="患者姓名"></el-table-column>
                <!-- <el-table-column width="120" prop="patientDeptName" label="患者科室"></el-table-column> -->
    
                <el-table-column width="160" prop="patientNo" label="住院号"></el-table-column>
                <el-table-column width="120" prop="surgicalStentName" label="手术名称"></el-table-column>
                <el-table-column width="120" prop="surgicalStentCategroyName" label="手术类型">
                  <template slot-scope="scope">
                    {{ scope.row.surgicalStentCategroyName?scope.row.surgicalStentCategroyName:'-' }}
                  </template>
                </el-table-column>
    
                <el-table-column width="120" prop="doctorName" label="手术医生"></el-table-column>
                <el-table-column width="120" prop="warehouseName" label="存放仓库"></el-table-column>
                <el-table-column width="180" prop="applyNo" label="来源跟台申请单号"></el-table-column>
                <el-table-column min-width="170"   prop="effectiveTime" label="生效时间">
                  <template slot-scope="scope">
                    <span>
                      {{ scope.row.effectiveTime?parseTime(new Date(scope.row.effectiveTime),  "{y}-{m}-{d} {h}:{i}:{s}"):'-' }}
                    </span>
                  </template>
                </el-table-column>
                <el-table-column width="120" prop="totalNumber" label="总数量"></el-table-column>
                <el-table-column width="120" prop="totalAmount" label="总金额"></el-table-column>
                <el-table-column  label="审批人" width="100" align="center" prop="approverNames">
                  <template slot-scope="scope">
                    {{ scope.row.approverNames?scope.row.approverNames:'-' }}
                  </template>
                </el-table-column>
                <el-table-column prop="statusName" label="流程状态" width="80" >
                    <template slot-scope="scope">
                        <approve-status  :row="scope.row" :isWorkflowTable="isWorkflowTable" :options="ApproveStatusOptions" @success="getData" :tableCode="route.name"></approve-status>
                    </template>
                </el-table-column>
                <el-table-column prop="remark" label="备注" min-width="160" show-overflow-tooltip>
                  <template slot-scope="scope">
                    {{ scope.row.remark?scope.row.remark:'-' }}
                  </template>
                </el-table-column>
                <el-table-column fixed="right" prop="operation" label="操作" width="180">
                    <template slot-scope="scope">
                        <!-- <el-button type="text" v-preventReClick @click="handleInfo(scope.row)" class="color-blue">查看</el-button> -->
                        <el-button v-if="scope.row.status == 1 && isShowApproveButton(scope.row.approverIds)" type="text" v-preventReClick @click="handleApprove(scope.row)" class="margin-left20 color-blue">审核</el-button>
                        <el-button v-else-if="
                    scope.row.status != 1 &&
                    scope.row.status != 2 &&
                    tableAcl.indexOf('Edit') != -1
                  " type="text" v-preventReClick @click="handleUpdate(scope.row)" class="margin-left20 color-blue">编辑</el-button>
                        <!-- <span v-else class="margin-left20 color-blue">&nbsp;&nbsp;-&nbsp;&nbsp;</span> -->
                        <el-button v-if="tableAcl.indexOf('Remove') != -1 && scope.row.status != 2" type="text" v-preventReClick @click="handleDelete(scope.row)" class="margin-left20 color-blue">删除</el-button>
                        <!-- <span v-else class="margin-left20 color-blue">&nbsp;&nbsp;-&nbsp;&nbsp;</span> -->
                        <el-button type="text" v-preventReClick @click="showRefundDialog(scope.row)" v-if="
                        scope.row.status == 2 &&
                        scope.row.state != 3 &&
                        scope.row.returnState == 1
                     " class="margin-left20 color-blue">退货</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
   
    </div>
    <div class="pagination">
        <el-pagination background layout="sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" :page-size="query.pageSize" @size-change="handleSizeChange" :current-page="query.pageIndex" :total="total" @current-change="changePage">
        </el-pagination>
    </div>
    <Transfer ref="Transfer" @getTabelList="getTabelList" :transfer-props="transferProps" />
</div>
</template>

<script>
import {
    GetDefaultWarehouse,
    GetSurgicalChecks,
    RemoveSurgicalCheck
} from "@/api";
import GetDataMixin from "@/mixin/getData-mixin.js";
import GetDataSpdMixin from "@/mixin/getData-spd-mixin.js";
import BaseListMixin from "@/mixin/baseList-mixin.js";
import {
    DistributionStateOptions,
    ApproveStatusOptions
} from "@/enum";
import SelectFilter from "@/components/table-select-filter";

export default {
    mixins: [GetDataMixin, GetDataSpdMixin, BaseListMixin],
    components: {
        SelectFilter,
    },
    data() {
        return {
            GetDatasAction: GetSurgicalChecks,
            RemoveAction: RemoveSurgicalCheck,
            // PrintAction: GetStockUpCheckPrintData,
            editPath: "surgical-check-edit",

            DistributionStateOptions: DistributionStateOptions,
            ApproveStatusOptions: ApproveStatusOptions,
            filterOptions: [{
                    name: "验收单号",
                    type: "input",
                    code: "keyWord",
                },
                {
                    name: "存放库房",
                    type: "select",
                    code: "warehouseId",
                    filterMethod: this.getWarehouses,
                    data: [],
                },
                {
                    name: "供应商",
                    type: "select",
                    code: "supplierId",
                    filterMethod: this.getSuppliers,
                    data: [],
                },
                {
                    name: "供货商产品",
                    type: "select",
                    code: "supplierProductId",
                    filterMethod: this.getSupplierProductsNoDebounce,
                    data: [],
                },
                {
                    name: "供应商产品编码",
                    type: "input",
                    code: "supplierProductNo",
                },
                {
                    name: "产品名称",
                    type: "input",
                    code: "productName",
                },
                {
                    name: "规格型号",
                    type: "input",
                    code: "specName",
                },
                {
                    name: "批次号",
                    type: "input",
                    code: "batch",
                },
                {
                    name: "供应商配送单号",
                    type: "input",
                    code: "drmSurgicalDistributionNo",
                },
                {
                    name: "住院号",
                    type: "input",
                    code: "patientNo",
                },
                {
                    name: "状态",
                    type: "select",
                    code: "state",
                    data: DistributionStateOptions,
                },
                {
                    name: "流程状态",
                    type: "select",
                    code: "statuses",
                    multiple: true,
                    data: ApproveStatusOptions,
                },
                // {
                //   name: "退库状态",
                //   type: "select",
                //   code: "refundState",
                //   data: [
                //     {
                //       name: '未退库',
                //       id: 0
                //     },
                //     {
                //       name: '已退库',
                //       id: 1
                //     }
                //   ],
                // },
                {
                    name: "日期范围",
                    type: "date",
                    code: "date",
                },
                {
                  name: "注册证号",
                  type: "input",
                  code: "productRegistCertNo",
                },
                {
                name: "主条码",
                type: "input",
                code: "mainNo",
                },
                {
                name: "来源跟台申请单号",
                type: "input",
                code: "applyNo",
                },
            ],
            // // 查询条件
            // query: {
            //   keyWord: "",
            //   pageSize: 10,
            //   pageIndex: 1,
            //   warehouseId: '',
            //   warehouseName: ''
            // },
            // // 列表数据
            // tableData: [],
            // // 列表总数
            // total: 0,
            // // 多选框数据
            // ids: [],
            // multipleSelection: [],
            // // 列表多选
            // multiple: true,
            // // RefundStateOptions:
        };
    },
    methods: {
        // handleSelectionChange (selection) {
        //   this.multipleSelection = selection;
        //   this.ids = selection.map((item) => item.id);
        //   this.multiple = !selection.length;
        // },
        // // 打印
        // print (command) {
        //   // const length = this.ids.length
        //   // if (length !== 1) {
        //   //   this.$my_message('请选择一条数据', 'warning')
        //   //   return
        //   // }

        //   for (let i = 0; i < this.ids.length; i++) {
        //     var id = this.ids[i]
        //     this.PrintAction({ id: id, type: command })
        //       .then(res => {
        //         var result = res.returnData

        //         var printData = this.printDataConvert(result.printData)
        //         this.sendPrintMessage(JSON.stringify(printData));
        //         if (i == this.ids.length) {
        //           this.getData()
        //         }
        //       })
        //   }
        // },
        // // 获取列表
        // getData () {
        //   this.GetDatasAction(this.query).then((res) => {
        //     this.tableData = res.returnData.data;
        //     this.total = res.returnData.totalCount;
        //     // this.$nextTick(() => {
        //     //   console.log(this.$refs.multipleTable)
        //     //   this.$refs.multipleTable.doLayout()
        //     // })
        //   });
        // }, // 删除部门
        // handleDelete (row) {
        //   const ids = row && row.id ? [row.id] : this.ids;

        //   this.$my_confirm("此操作将删除数据，是否继续？", "提示", {
        //     type: "warning",
        //   })
        //     .then(() => {
        //       return this.RemoveAction({ ids });
        //     })
        //     .then(() => {
        //       this.$my_message(`操作成功！`, "success");
        //       this.getData();
        //     })
        //     .catch(() => { });
        // },

        // // 查看信息
        // handleInfo (row) {
        //   // this.$router.push("/" + this.editPath + "?formMode=0&id=" + row.id);
        //   this.routePushWithParams("/" + this.editPath, this.query, { formMode: 0, id: row.id });
        // },
        // // 新建
        // handleAdd () {
        //   // this.$router.push("/" + this.editPath + "?formMode=1");
        //   this.routePushWithParams("/" + this.editPath, this.query, { formMode: 1 });
        // },
        // // 编辑
        // handleUpdate (row) {
        //   // this.$router.push("/" + this.editPath + "?formMode=2&id=" + row.id);
        //   this.routePushWithParams("/" + this.editPath, this.query, { formMode: 2, id: row.id });
        // },
        // // 审批
        // handleApprove (row) {
        //   // this.$router.push("/" + this.editPath + "?formMode=3&id=" + row.id);
        //   this.routePushWithParams("/" + this.editPath, this.query, { formMode: 3, id: row.id });
        // },
        // // 改变当前页
        // changePage (val) {
        //   this.$set(this.query, "pageIndex", val);
        //   this.getData();
        // },
        // handleSizeChange (val) {
        //   this.$set(this.query, "pageSize", val);
        //   this.getData();
        // },

        // // 重置
        // reset () {
        //   this.query = {
        //     keyWord: "",
        //     pageSize: 10,
        //     pageIndex: 1,
        //     warehouseId: '',
        //     warehouseName: ''
        //   };
        //   if (this.$refs["selectFilter"]) {
        //     this.$refs["selectFilter"].resetQuery();
        //   }
        //   this.ids = []
        //   this.multipleSelection = []
        //   this.multiple = true;

        //   if (this.$refs.multipleTable) {
        //     this.$refs.multipleTable.clearSelection()
        //   }
        //   this.getData();
        // },
        // queryChange () {
        //   this.$set(this.query, "pageIndex", 1);
        //   this.getData();
        // },

        // getDefaultWarehouse () {
        //   GetDefaultWarehouse({ deptId: this.userInfo.deptId })
        //     .then(res => {
        //       if (res.successful && res.returnData.id) {
        //         // this.$set(this.query, 'warehouseId', res.returnData.id)
        //         this.query.warehouseId = res.returnData.id
        //         this.query.warehouseName = res.returnData.name
        //         this.$refs["selectFilter"].query.warehouseId = res.returnData.id
        //         this.$refs["selectFilter"].query.warehouseIdName = res.returnData.name
        //       }

        //       this.getData()
        //     })
        // },
        showRefundDialog(row) {
            // this.$router.push("/surgical-refund-edit?formMode=1&checkId=" + row.id);
            this.routePushWithParams("/surgical-refund-edit", this.query, {
                formMode: 1,
                checkId: row.id,
            });
        },
    },
    created() {
        // 分页组件默认值需要早created
        // if (this.$route.params) {
        //   this.query = this.$route.params
        // }
    },
    mounted() {
        // 查询组件默认值需要在mounted
        // if (this.$route.params) {
        //   this.$refs["selectFilter"].query = this.query
        // }
        // this.getDefaultWarehouse()
    },
};
</script>

<style lang="scss" scoped></style>
